//Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

//3rd party imports
import { plainToInstance } from 'class-transformer';

//RxJs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

//Service imports
import { RPCacheRegistrationService } from '../../../_services/shared-services/rp-cache-registration-service';

//Model imports
import { BaseResidentParameterDto } from '../../../_models/base-resident-parameter-dto';
import { InformationResultDto } from '../../_models/information-result-dto';
import { AmenityDetailParameterDto } from '../../_models/amenity-detail-parameter-dto';
import { AmenityDetailResultDto } from '../../_models/amenity-detail-result-dto';

//Service imports
import { EnvironmentConfigService } from '../../../_services/environment-config.service';

//Constants
import { CacheDuration } from '../../../_constants/cache-duration';

@Injectable({
  providedIn: 'root'
})
export class InformationService {
  constructor(
    private httpClient: HttpClient,
    private cacheRegistrationService: RPCacheRegistrationService,
    private envConfig: EnvironmentConfigService
  ) {}

  getCommunityInformation(
    data: BaseResidentParameterDto
  ): Observable<InformationResultDto[]> {
    const url =
      this.envConfig.ccResidentPortalApiUrl +
      'community/info' +
      data.getQueryString();
    this.cacheRegistrationService.registerForCache(url, data.clearCache);
    const headers = this.cacheRegistrationService.getHttpRequestHeaders(
      url,
      CacheDuration.fifteenMinute
    );
    const options = { headers: headers };

    return this.httpClient
      .get<InformationResultDto[]>(url, options)
      .pipe(
        map((responseData: any[]) =>
          plainToInstance(InformationResultDto, responseData)
        )
      );
  }

  getAmenityInformation(
    data: AmenityDetailParameterDto
  ): Observable<AmenityDetailResultDto> {
    const url =
      this.envConfig.ccResidentPortalApiUrl +
      'community/amenity/detail' +
      data.getQueryString();
    this.cacheRegistrationService.registerForCache(url, data.clearCache);
    const headers = this.cacheRegistrationService.getHttpRequestHeaders(
      url,
      CacheDuration.fifteenMinute
    );
    const options = { headers: headers };

    return this.httpClient
      .get<AmenityDetailResultDto>(url, options)
      .pipe(
        map((responseData: any) =>
          plainToInstance(AmenityDetailResultDto, responseData)
        )
      );
  }

  getAmenityReservationForm(formUrl: string): Observable<Blob> {
    return this.httpClient
      .get(formUrl, { responseType: 'arraybuffer' })
      .pipe(map((responseData: any) => new Blob([responseData])));
  }
}
